/**
 * The library while an övningstenta is running (spec §4.5, ruling 6, slice D fix I1): only the
 * formula sheet is open; topics and the old-exam archive (with its solutions) say so and lead back
 * to the session. `examActive` is server-backed, so a new tab gets the same restriction.
 */
import { Link, Outlet, useLocation } from "react-router";
import { ExamCheckFailed } from "@client/app/ExamCheckFailed";
import { useExamMode } from "@client/app/examMode";
import { EmptyState, Spinner } from "@client/components/ui";
import { useT } from "@client/i18n";

export function LibraryExamGuard() {
  const t = useT();
  const { examActive, examChecking, examError } = useExamMode();
  const { pathname } = useLocation();
  if (/^\/library\/formulas\/?$/.test(pathname)) return <Outlet />;
  // A fresh tab must not flash the archive's solutions before the server has answered.
  if (examChecking) return <Spinner size="md" label={t("common.loading")} />;
  // Fail closed: an unanswered check keeps the page locked and offers a retry.
  if (examError) return <ExamCheckFailed />;
  if (!examActive) return <Outlet />;
  return (
    <div className="mx-auto max-w-2xl">
      <EmptyState
        title={t("content.examLocked.title")}
        body={t("content.examLocked.body")}
        action={
          <p className="flex flex-wrap justify-center gap-4 text-sm font-medium">
            <Link to="/library/formulas" className="underline underline-offset-2">
              {t("content.examLocked.formulas")}
            </Link>
            <Link to="/exam/session" className="underline underline-offset-2">
              {t("content.examLocked.back")}
            </Link>
          </p>
        }
      />
    </div>
  );
}
